<dialog-window [title]="title" (close)="close()" [modal]="false" focusOnCloseButton="true">
    <div tabindex="1" id="video-container" #videoContainer (keyup.enter)="fullScreen()">
        <video id="video" #video controls autoplay></video>
    </div>
    <div dialog-footer>
        <div>
            <span tabindex="1" *ngIf="epgCurrent" title="Нажмите, для отображения программы на день!" (click)="epg_day()" (keyup.enter)="epg_day()">
                <b>{{epgCurrent.start*1000 | date:'HH:mm'}} -
                    {{epgCurrent.stop*1000 | date:'HH:mm'}}</b>&nbsp;
                <i>{{epgCurrent.programm}}</i>
            </span>
        </div>
    </div>
</dialog-window>